import React from "react";
import { Link } from "react-router-dom";
import a1 from "../Accests/about/a1.jpg";
import a2 from "../Accests/about/a2.jpg";
import a3 from "../Accests/about/a3.jpg";
import a6 from "../Accests/about/abot.png";

export const AboutUs = () => {
    return (
        <>
            <div data-aos="fade-up" id="about" className="w-full lg:h-screen h-full m-auto flex items-center justify-center py-20 bg-gray-50 dark:bg-gray-900 mt-10">
                <div className="w-full h-full flex flex-col justify-center items-center sm:px-4 px-2">
                    <div data-aos="fade-up"
                         className="lg:w-[90%] w-full mx-auto flex flex-col lg:gap-6 lg:flex-row items-center justify-center">
                        <div className="relative flex justify-center items-center">
                            {/* Side images */}
                            <img
                                className="absolute z-20 lg:left-[2rem] -top-4 left-[1rem]
               lg:w-[8rem] lg:h-[8rem] sm:w-[6rem] sm:h-[6rem] w-[3rem] h-[3rem]
               rounded-full"
                                src={a1}
                                alt="Side Image"
                            />
                            <img
                                className="absolute z-20 lg:top-[12rem] sm:top-[11rem] top-[5rem]
               sm:-left-[3rem] -left-[2rem]
               lg:w-[8rem] lg:h-[8rem] sm:w-[6rem] sm:h-[6rem] w-[3rem] h-[3rem]
               rounded-full"
                                src={a2}
                                alt="Side Image 2"
                            />
                            <img
                                className="absolute z-20 lg:top-[23rem] sm:top-[15.5rem] top-[8.0rem]
left-[2rem]
lg:w-[8rem] lg:h-[8rem] sm:w-[6rem] sm:h-[6rem] w-[3rem] h-[3rem]
rounded-full"

                                src={a3}
                                alt="Side Image 3"
                            />

                            {/* Center circle with new style */}
                            <div className="
    rounded-full
    p-2
    bg-gradient-to-r from-green-400 via-blue-400 to-purple-400
    animate-pulse
  ">
                                <img
                                    className="
        rounded-full
        object-cover
        w-32 h-32
        sm:w-48 sm:h-48
        lg:w-[30rem] lg:h-[30rem]
        shadow-xl
        transform transition-transform duration-500 hover:scale-105
      "
                                    src={a6}
                                    alt="About Us"
                                />
                            </div>
                        </div>


                        <div
                            className="lg:w-[60%] p-4 w-full h-full shadow-xl shadow-green-300/40 flex flex-col justify-center items-center sm:px-6 px-4 rounded-xl">
                            <h2 className="text-4xl text-center text-green-600 dark:text-green-400 font-bold px-4 py-1 md:mt-0 mt-10">
                                About Us
                            </h2>
                            <p className="md:text-3xl text-2xl text-center text-gray-800 dark:text-gray-200 font-bold my-5">
                                Welcome to No Limit Tour Randombe,
                            </p>
                            <p className="md:text-xl sm:text-lg text-base mt-2 text-justify sm:px-2 dark:text-gray-300">
                                your trusted partner in creating unforgettable travel experiences. Nestled in the heart
                                of Sri Lanka, we are a dedicated tourism company passionate about showcasing the beauty,
                                culture, and adventure our country has to offer.

                                At No Limit Tour Randombe, we believe every journey is an opportunity to create lasting
                                memories. Whether you're seeking serene beaches, lush landscapes, or rich cultural
                                heritage, our tailored tours are designed to suit your unique preferences. Our
                                experienced team is committed to delivering exceptional service, ensuring your travels
                                are seamless, enjoyable, and filled with authentic local experiences.

                                Join us at No Limit Tour Randombe, where your dream vacation becomes a reality, and
                                every adventure has no limits. Let's explore together!
                            </p>

                            <Link to="/about-details">
                                <button
                                    className="lg:mt-10 mt-6 lg:px-6 px-4 lg:py-4 py-2 bg-green-600 rounded-sm lg:text-xl text-lg text-white font-semibold">
                                    Read More
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
